<template>
  <section class="agent-plan-dashboard py-6 px-4">
    <b-container fluid>
      <b-card class="border-0 shadow-sm mb-4">
        <template #header>
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div>
              <h2 class="h4 text-primary mb-1">Agent Plan Dashboard</h2>
              <p class="mb-0" style="color: #495057 !important;">
                Tus afiliados, sus citas y tus comisiones. Sin fechas se muestra el mes en curso.
              </p>
            </div>
          </div>
        </template>

        <b-form @submit.prevent="applyRange">
          <b-row class="align-items-end">
            <b-col cols="12" md="3" class="mb-3">
              <label class="font-weight-semibold">Desde</label>
              <flat-pickr v-model="filters.start_date" :config="dateConfig" class="form-control" placeholder="YYYY-MM-DD" />
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
              <label class="font-weight-semibold">Hasta</label>
              <flat-pickr v-model="filters.end_date" :config="dateConfig" class="form-control" placeholder="YYYY-MM-DD" />
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
              <b-button type="submit" variant="primary" :disabled="loading">
                <span v-if="!loading">Buscar</span>
                <b-spinner v-else small label="Loading..."></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-form>

        <b-alert v-if="errorMessage" show variant="danger" dismissible @dismissed="errorMessage = null">
          {{ errorMessage }}
        </b-alert>

        <b-spinner v-if="loading && !summary" label="Loading..." class="d-block mx-auto my-5"></b-spinner>
        <agent-summary-cards v-if="summary" :summary="summary" />
      </b-card>

      <b-card class="border-0 shadow-sm" no-body>
        <b-tabs card>
          <b-tab title="Afiliados" active>
            <agent-affiliates-table />
          </b-tab>
          <b-tab title="Citas">
            <agent-appointments-table :range="range" />
          </b-tab>
          <b-tab title="Solicitudes de cita">
            <agent-requests-table :range="range" />
          </b-tab>
          <b-tab title="Comisiones por mes">
            <commission-months-table />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import { BAlert, BButton, BCard, BCol, BContainer, BForm, BRow, BSpinner, BTab, BTabs } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import agentPlanService from '@/core/services/api/agentPlan'
import { formatYmd } from '@/core/utils/dashboardDates'
import { rangeParams } from '@/core/utils/agentPlanDashboard'
import { membershipApiMessage } from '@/core/utils/membershipAdmin'
import AgentSummaryCards from './dashboard/AgentSummaryCards.vue'
import AgentAffiliatesTable from './dashboard/AgentAffiliatesTable.vue'
import AgentAppointmentsTable from './dashboard/AgentAppointmentsTable.vue'
import AgentRequestsTable from './dashboard/AgentRequestsTable.vue'
import CommissionMonthsTable from './dashboard/CommissionMonthsTable.vue'

export default {
  name: 'AgentPlanDashboard',
  components: {
    BAlert,
    BButton,
    BCard,
    BCol,
    BContainer,
    BForm,
    BRow,
    BSpinner,
    BTab,
    BTabs,
    flatPickr,
    AgentSummaryCards,
    AgentAffiliatesTable,
    AgentAppointmentsTable,
    AgentRequestsTable,
    CommissionMonthsTable,
  },
  data() {
    const today = new Date()
    const filters = {
      start_date: formatYmd(new Date(today.getFullYear(), today.getMonth(), 1)),
      end_date: formatYmd(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
    }
    return {
      loading: false,
      errorMessage: null,
      summary: null,
      filters,
      range: { ...filters },
      dateConfig: {
        dateFormat: 'Y-m-d',
        allowInput: true,
      },
    }
  },
  mounted() {
    this.loadSummary()
  },
  methods: {
    applyRange() {
      const { start_date: start, end_date: end } = this.filters
      // El backend pide las dos fechas o ninguna (mes en curso).
      if (!start !== !end) {
        this.errorMessage = 'Elige las dos fechas o deja ambas vacías para ver el mes en curso.'
        return
      }
      if (start && end && start > end) {
        this.errorMessage = 'La fecha inicial debe ser anterior o igual a la final.'
        return
      }
      this.range = { ...this.filters }
      this.loadSummary()
    },
    async loadSummary() {
      this.loading = true
      this.errorMessage = null
      try {
        const response = await agentPlanService.getDashboardSummary(rangeParams(this.range))
        this.summary = (response && response.data) || null
      } catch (error) {
        this.summary = null
        this.errorMessage = membershipApiMessage(error, 'No se pudo cargar el panel del agente. Intenta de nuevo.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
